// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202511251304/js/" + chunkId + "." + {"44":"130a17cb","225":"56ab6d71","481":"a63e4c2a","486":"783d618d","770":"67964757"}[chunkId] + ".0.07212580849998029.chunk.js";
};